/**
 * Milestone 2 vertical slice — one mid-height shelf with treat + toy slots.
 *
 * See docs/PLAN.md §4.6 (Shelves & Reach).
 */

import { BEDROOM_DEFAULT, bedTopY } from './bedroom.js';

export type ShelfLootKind = 'treat' | 'toy';

export interface ShelfDef {
  readonly id: string;
  readonly displayName: string;
  /** Shelf zone in world space (y-down). */
  readonly x: number;
  readonly y: number;
  readonly width: number;
  readonly height: number;
  /** Stack height above bed surface required before paw can reach. */
  readonly minReachHeight: number;
  readonly treatSlotX: number;
  readonly toySlotX: number;
}

const worldH = BEDROOM_DEFAULT.playfieldHeight;
const surfaceY = bedTopY(worldH);

/** Wall shelf above the nightstand — treat (safe) and toy (risky). */
export const ARCADE_SHELF: ShelfDef = {
  id: 'shelf_mid_left',
  displayName: 'Mid shelf',
  x: 6,
  y: surfaceY - 220,
  width: 88,
  height: 36,
  minReachHeight: 72,
  treatSlotX: 28,
  toySlotX: 62,
};

/** True if a world point lies inside the shelf zone. */
export function isPointInShelf(shelf: ShelfDef, wx: number, wy: number): boolean {
  return (
    wx >= shelf.x && wx <= shelf.x + shelf.width && wy >= shelf.y && wy <= shelf.y + shelf.height
  );
}

/** Which loot slot was tapped, if any. */
export function shelfLootAtPoint(shelf: ShelfDef, wx: number, wy: number): ShelfLootKind | null {
  if (!isPointInShelf(shelf, wx, wy)) return null;
  const localX = wx - shelf.x;
  return localX < shelf.width * 0.5 ? 'treat' : 'toy';
}
